export const GET_FINISHED_PRODUCT = 'GET_FINISHED_PRODUCT';
export const GET_FINISHED_PRODUCT_SUCCESS = 'GET_FINISHED_PRODUCT_SUCCESS';
export const GET_FINISHED_PRODUCT_FAIL = 'GET_FINISHED_PRODUCT_FAIL';

export const CONFIRM_FINISHED_PRODUCT = 'CONFIRM_FINISHED_PRODUCT';
export const CONFIRM_FINISHED_PRODUCT_SUCCESS = 'CONFIRM_FINISHED_PRODUCT_SUCCESS';
export const CONFIRM_FINISHED_PRODUCT_FAIL = 'CONFIRM_FINISHED_PRODUCT_FAIL';

export const STORNO_FINISHED_PRODUCT = 'STORNO_FINISHED_PRODUCT';
export const STORNO_FINISHED_PRODUCT_SUCCESS = 'STORNO_FINISHED_PRODUCT_SUCCESS';
export const STORNO_FINISHED_PRODUCT_FAIL = 'STORNO_FINISHED_PRODUCT_FAIL';

export const SET_CANCEL_SEND_TO_SAP = 'SET_CANCEL_SEND_TO_SAP';
export const SET_CANCEL_SEND_TO_SAP_SUCCESS = 'SET_CANCEL_SEND_TO_SAP_SUCCESS';
export const SET_CANCEL_SEND_TO_SAP_FAIL = 'SET_CANCEL_SEND_TO_SAP_FAIL';
